<nb-layout>

  <nb-layout-header>
  
    <h1>TIC-TAC-TOE</h1>
    
  <!-- Insert header here -->
  </nb-layout-header>

  <nb-layout-column>
    <!-- <app-square [value]="'X'"></app-square> -->
    <app-board></app-board>
    <!-- <router-outlet></router-outlet> -->
    
  </nb-layout-column>

  <nb-layout-footer fixed>
    <p>Author
      Levani Papashvili @2021</p>
  <!-- Insert footer here -->
  </nb-layout-footer>

</nb-layout>
